var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStopProject(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 23,
    height: 23,
    rx: 11.5,
    stroke: "#6651BD"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 12C6 9.50018 6 8.25027 6.63661 7.37405C6.84221 7.09107 7.09107 6.84221 7.37405 6.63661C8.25027 6 9.50018 6 12 6C14.4998 6 15.7497 6 16.626 6.63661C16.9089 6.84221 17.1578 7.09107 17.3634 7.37405C18 8.25027 18 9.50018 18 12C18 14.4998 18 15.7497 17.3634 16.626C17.1578 16.9089 16.9089 17.1578 16.626 17.3634C15.7497 18 14.4998 18 12 18C9.50018 18 8.25027 18 7.37405 17.3634C7.09107 17.1578 6.84221 16.9089 6.63661 16.626C6 15.7497 6 14.4998 6 12Z",
    fill: "#6651BD",
    stroke: "#6651BD",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStopProject);
export default __webpack_public_path__ + "static/media/stop-project.8feb0042220647fd635134319fe4d49a.svg";
export { ForwardRef as ReactComponent };